import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { ComponentsService } from '../../services/ComponentsService';
import { customStyles, the } from './customStyles';

const SuperMasterDropdown = ({ adminId,setSelectedOption, menuPlacement}) => {
  const [supermaster, setSupermaster] = useState([]);
  const [selectedOption, setSelectedOptionInternal] = useState(null);

  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const res = await ComponentsService.getSuperMaster({ adminId });

        if (res.code === 1 && res.data.adminList.length > 0) {
          setSupermaster(res.data.adminList); 
        }
      } catch (error) {
        console.error('Error fetching admin data:', error);
      }
    };

    if (adminId) {
      fetchAdminData();
    }
  }, [adminId]);
  


  const adminOptions = supermaster.map((item) => ({
    value: item.adminId,
    label: `${item.firstName} (${item.userName})`, 
  }));

  const handleSelectChange = (selected) => {
    setSelectedOptionInternal(selected); 
    setSelectedOption(selected); 
  };

    return (
    <div>
      <Select
        menuPlacement={menuPlacement}
        options={adminOptions}
        value={selectedOption}
        onChange={handleSelectChange} 
        placeholder="Select "
        isSearchable
        className=" text-black fss-01 small-select " 
        theme={the} styles={customStyles}
        isClearable
      />
    </div>
  );

};


export default SuperMasterDropdown;
